import { useSelector } from 'react-redux';
import { Store } from 'src/redux/Store';
import { DIALOGS } from 'src/models/DialogModel';

interface Props {
  dialogKey: DIALOGS;
  component: React.ComponentType;
}

const DialogWrapper = ({ dialogKey, component: Component }: Props) => {
  const opened = useSelector((state: Store) => !!state.dialog[dialogKey]?.opened);

  if (!opened) return null;

  return <Component />;
};

export default DialogWrapper;
